<script setup>
import {Link} from "@inertiajs/vue3"
</script>

<template>
    <Link class="c-link" href="">
        <slot/>
    </Link>
</template>

<style>
.c-link {
    color: #141312;
    text-decoration: none;
}
a.c-link {
    cursor: pointer;
}
</style>
